class BootstrapWrapper {
    constructor() {
        this.entryContent = document.querySelector('.entry-content');
        this.init();
    }

    init() {
        if (!this.entryContent) return; // Exit if .entry-content is not found

        Array.from(this.entryContent.children).forEach(child => {
            if (child.classList.contains('page-banner')) {
                // Skip the banner block
                return;
            }

            const container = document.createElement('div');
            container.className = 'container';

            const row = document.createElement('div');
            row.className = 'row';
            container.appendChild(row);

            const col = document.createElement('div');
            col.className = 'col-12 col-lg-6';
            row.appendChild(col);

            // Move the block to the new Bootstrap structure
            col.appendChild(child);

            // Append the new Bootstrap structure to .entry-content
            this.entryContent.appendChild(container);
        });
    }
}

// Initialize the class when DOM is fully loaded
// document.addEventListener('DOMContentLoaded', () => {
//     new BootstrapWrapper();
// });

export default BootstrapWrapper